module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ;  _.each(control.drawControls, function(control) { 
    ; __append("\n<div class=\"control ")
    ; __append(escapeFn( control.disabled ? "disabled" : "" ))
    ; __append("\"\n     title=\"")
    ; __append(escapeFn( [control.label, control.description].join("\n") ))
    ; __append("\"\n     data-action=\"")
    ; __append(escapeFn( control.action ))
    ; __append("\"\n     on-click=\"onControlClick\" ")
    ; __append(escapeFn( control.disabled ? "disabled" : "" ))
    ; __append("\n>\n    <span class=\"")
    ; __append(escapeFn( control.classes ))
    ; __append("\"></span>\n</div>\n")
    ;  }); 
  }
  return __output.join("");

}